import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
// import emailjs from "@emailjs/browser";
import thankyou from "../images/thankyou.png";
import { Modal, Box, Typography, Button,  } from "@mui/material"; //IconButton
import { useNavigate } from "react-router-dom";
import { getApiUrl } from "../config";

const ThankYou = () => {
  // const [status, setStatus] = useState(null);
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const hasRunEffect = useRef(false); 

  const handleClose = () => {
    setOpen(false);
    navigate("/");
  };
  useEffect(() => {
    if (hasRunEffect.current) return; // Prevent reruns
    hasRunEffect.current = true;
    const orderId = sessionStorage.getItem("orderId");
    const subscriptionId = sessionStorage.getItem("subscriptionId");
    console.log(orderId);

    const data = {
      customer_name: sessionStorage.getItem("customer_name"),
      customer_email: sessionStorage.getItem("customer_email"),
      order_amount: sessionStorage.getItem("order_amount"),
      order_currency: sessionStorage.getItem("order_currency"),
      honor_name: sessionStorage.getItem("honor_name"),
      honor_email: sessionStorage.getItem("honor_email"),
    };

    console.log("email data from session storage ==== ", data);

    const sendEmail = async () => {
      try {
        const email = await axios.post(
          getApiUrl("/api/oneTime/sendOrderEmail"),
          data
        );
        console.log("checking response ==== ", email.data);
      } catch (error) {
        console.error("Email error: ", error);
        alert("An error occurred. Please try again.");
      }
    };

    const fetchOrderStatus = async () => {
      try {
        let response;
        if (orderId) {
          response = await axios.get(getApiUrl(`/api/oneTime/getOrderStatus/${orderId}`));
          console.log("Order response", response.data);
        } else if (subscriptionId) {
          response = await axios.get(getApiUrl(`/api/subscription/getSubscriptionStatus/${subscriptionId}`));
        }
        
        if (response && response.data && response.data.order_status === "PAID") {
          sendEmail();
        } else {
          navigate('/');
        }
      } catch (error) {
        console.error("Error fetching order status", error);
      }
    };

    fetchOrderStatus();
  }, [navigate]);
  const isMobile=window.innerWidth<=992

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="thank-you-title"
        aria-describedby="thank-you-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile? 300:800,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            textAlign: "center",
            border: "4px solid white",
          }}
        >
          <img
            src={thankyou}
            style={{
              width: "10%",
              height: "10%", // or any specific width you'd like
            }}
            alt="Thank You"
          />
          <Box>
            <Typography
              id="thank-you-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: 600, fontSize: "48px",color: "#00345B", }}
            >
              Thank you for{" "}
            </Typography>
            <Typography
              component="span"
              sx={{ color: "#09AACC", fontWeight: 600, fontSize: "48px" }}
            >
              Your Donation
            </Typography>
          </Box>

          <Typography
            id="thank-you-description"
            sx={{
              mt: 2,
              color: "#888888",
              fontSize: 24,
              lineHeight: "34px",
              marginBottom: 4,
            }}
          >
            On behalf of Sood Charity Foundation, we want to extend our deepest
            gratitude for your generous donation. Your support is a testament to
            the kindness and compassion that drives meaningful change in our
            community.
          </Typography>

          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              bgcolor: "#14213D",
              "&:hover": {
                bgcolor: "primary.dark",
              },
              borderRadius: 30,
            }}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default ThankYou;
